import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import HeroSection from './HeroSection';
import BrandSlider from './BrandSlider';
import ServicesSection from './ServicesSection';
import ProductsSection from './ProductsSection';
import IndustriesSection from './IndustriesSection';
import WhyNexfahSection from './WhyNexfahSection';
import CTASection from './CTASection';
import SEO from '../../components/SEO';

/**
 * Builds a responsive height object from MUI's theme.mixins.toolbar.
 * This ensures the hero+slider wrapper always subtracts the exact toolbar
 * height at every breakpoint — no hardcoded values.
 *
 * theme.mixins.toolbar shape:
 *   { minHeight: 56,
 *     '@media (min-width:0px) and (orientation:landscape)': { minHeight: 48 },
 *     '@media (min-width:600px)': { minHeight: 64 } }
 */
function useAboveTheFoldHeight() {
  const theme = useTheme();
  const toolbar = theme.mixins.toolbar;

  // Base height (mobile portrait)
  const styles = {
    height: `calc(100dvh - ${toolbar.minHeight}px)`,
    // dvh fallback for older browsers
    '@supports not (height: 100dvh)': {
      height: `calc(100vh - ${toolbar.minHeight}px)`,
    },
  };

  // Apply each media-query variant from the toolbar mixin
  Object.entries(toolbar).forEach(([key, value]) => {
    if (typeof value === 'object' && value.minHeight !== undefined) {
      styles[key] = {
        height: `calc(100dvh - ${value.minHeight}px)`,
        '@supports not (height: 100dvh)': {
          height: `calc(100vh - ${value.minHeight}px)`,
        },
      };
    }
  });

  return styles;
}

export default function Home() {
  const aboveTheFold = useAboveTheFoldHeight();

  return (
    <>
      <SEO
        title="Nexfah | Digital Transformation & Automation"
        description="Nexfah helps businesses digitize processes and automate workflows to accelerate growth."
        url={typeof window !== 'undefined' ? window.location.href : '/'}
        image="/favicon.png"
      />

      {/* Hero + brand slider locked to exactly one viewport height */}
      <Box sx={{ ...aboveTheFold, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <HeroSection />
        <BrandSlider />
      </Box>

      <ServicesSection />
      <ProductsSection />
      <IndustriesSection />
      <WhyNexfahSection />
      <CTASection />
    </>
  );
}
